import { useState } from "react";
import { RiGroupLine } from "react-icons/ri";
import StationVehicles from "./StationVehicles";

export default function CheckpointWidget(props: any) {
  const [detailModal, setDetailModal] = useState<boolean>(false);
  const { name, values, handleSelected } = props;
  return (
    <div className="col-span-12 md:col-span-2 sm:col-span-2 border p-2 bg-white">
      <button
        className="flex justify-start"
        onClick={() => handleSelected({ name, values })}
      >
        <div className="bg-red-100 w-10 h-10 mr-2 flex justify-center items-center rounded-lg">
          <RiGroupLine />
        </div>
        <div className="flex flex-col items-start px-2 border-l">
          <div className="font-bold truncate w-40 flex justify-start">
            {name}
          </div>
          <div className="text-gray-500">{values?.length ?? 0}</div>
        </div>
      </button>
      {/* <StationVehicles
        isVisible={detailModal}
        setVisible={setDetailModal}
        vehicles={values}
        title={name}
        refetch={() => {}}
      /> */}
    </div>
  );
}
